// extracted by mini-css-extract-plugin
export default {"bottomVector":"NvProjects_bottomVector__kiu5H"};